import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/client";
import Icon from "./Icon";

// Muestra los anuncios de mejoras dirigidos al usuario como una tarjeta en la
// esquina inferior izquierda. Se cierra UNA sola vez (POST /visto) y no vuelve.
export default function AnunciosPopup() {
  const nav = useNavigate();
  const [cola, setCola] = useState([]);

  useEffect(() => {
    let vivo = true;
    api.get("/anuncios/pendientes").then((r) => { if (vivo) setCola(r.data.items || []); }).catch(() => {});
    return () => { vivo = false; };
  }, []);

  if (!cola.length) return null;
  const a = cola[0];
  const cerrar = async () => {
    setCola((c) => c.slice(1));
    try { await api.post(`/anuncios/${a.id}/visto`); } catch { /* reintenta en el próximo login */ }
  };
  const verMas = () => { const l = a.link; cerrar(); if (l) nav(l); };

  return (
    <div className="fixed bottom-4 left-4 z-[60] w-[min(92vw,22rem)]">
      <div className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-2xl">
        <div className="flex items-start gap-2 border-b border-slate-100 bg-brand-50 px-4 py-2.5">
          <Icon name="bell" size={16} className="mt-0.5 shrink-0 text-brand-600" />
          <b className="min-w-0 flex-1 text-sm text-slate-800">{a.titulo}</b>
          <button onClick={cerrar} aria-label="Cerrar" className="shrink-0 text-slate-400 hover:text-slate-700"><Icon name="x" size={16} /></button>
        </div>
        <div className="px-4 py-3 text-xs text-slate-600">
          {a.mensaje && <p className="whitespace-pre-line">{a.mensaje}</p>}
          <div className="mt-3 flex items-center justify-end gap-2">
            {a.link && <button onClick={verMas} className="btn-primary !py-1 text-xs">Ver más</button>}
            <button onClick={cerrar} className="btn-ghost !py-1 text-xs">Entendido</button>
          </div>
          {cola.length > 1 && <p className="mt-1 text-right text-[10px] text-slate-400">+{cola.length - 1} más</p>}
        </div>
      </div>
    </div>
  );
}
